import { MenuItem } from '../shared/efaact-primeng.module';

export interface IStatusMessage {
    StatusCode: ResponseStatus;
    Message: string;
    MsgProcessID?: number;
    MsgEntityID?: string | number;
}
export interface IPessimisticUpdate {
    Row_Version?: string;
}
export enum ResponseStatus {
    Unknown = -1,
    None = 0,
    Success = 1,
    Warning = 2,
    Failed = 3,
    Error = 3,
    ConcurrencyViolation = 4,
    PartialSuccess = 5,
    LoginExpired = 6,
    Adding = 10,
    ClientError = 50,
    FileFormatError = 51,
    Loading = 99
}
export const DisplayMessageMinimum = ResponseStatus.Warning;

export enum DateOperator {
    GreaterThan = 'gt',
    GreaterThanOrEqual = 'ge',
    Equal = 'eq',
    LessThanOrEqual = 'le',
    LessThan = 'lt'
}

export interface IDateAndOperator {
    Date: Date;
    Operator: DateOperator;
}
export declare type IId = string | number;
export interface IModelWithId {
    id: IId;
}
export interface IModelWithOptionalId {
    id?: IId;
}
// TODO: switch this to extend IModelWithId
export interface IModelBase extends IModelWithOptionalId {
    Status?: IStatusMessage;
}

export interface IDeleteEntity extends IPessimisticUpdate {
    EntityID: IId;
    Status: IStatusMessage;
    Row_Version: string;
}
export interface IGenericResponse<T extends IModelBase> {
    id?: IId;
    processId?: number;
    StatusCode: number;
    ErrorMessages: Array<string>;
    WarningMessages: Array<string>;
    Items: Array<T>;
    StatusType: string;
}

export interface IColumn extends MenuItem {
    field: string;
    header: string;
    style?: { [klass: string]: any };
    class?: string;
    formatType?: string;
    format?: string;
    colspan?: number;
    showColumn: boolean;
    group: string;
    exportable?: boolean;
}
